import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const SkinAnalyserWrapper = styled.div`
  padding: 0.5rem;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  border-radius: 0.5rem;
  box-shadow: 0px 1px 2px 0px rgba(71, 71, 71, 0.06),
    0px 4px 8px 0px rgba(71, 71, 71, 0.1);

  flex-direction: column;
  padding: 0;
  margin-top: -0.5rem;
  margin-bottom: 1.5rem;

  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    margin: 0.5rem 0;

    margin-top: -0.5rem;
    margin-bottom: 1.5rem;
    flex-direction: row;
  }

  @media (min-width: ${breakpoints.lg}) {
    margin: 0;
    margin-bottom: 3rem;
    flex-direction: row;
  }
`;

export const Image = styled.img`
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    width: 23.31rem;
  }
`;
export const DescriptionAndActionWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;

  padding: 1.25rem 1rem;
  gap: 0.5rem;
  flex: initial;

  @media (min-width: ${breakpoints.md}) {
    padding: 1.25rem;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 0.5rem;

  @media (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg}) {
    margin-top: 0.75rem;
  }

  @media (min-width: ${breakpoints.md}) {
    align-self: flex-start;
  }
`;

export const StyledTitle = styled.span`
  ${theme.typography.titleSmall}
`;
export const StyledDescription = styled.span`
  ${theme.typography.bodyRegular}
  color: ${theme.color.text.secondary};
`;
